import { cn, getUserInitials } from "@/lib/utils"
import { AvatarImage } from "@/components/ui/avatar-image"
import { Icon } from "@/components/ui/icon"

interface PlayerListItemProps {
  name: string
  role: string
  avatar?: string
  status: "confirmed" | "pending_payment" | "waiting"
  className?: string
}

export function PlayerListItem({ name, role, avatar, status, className }: PlayerListItemProps) {
  const initials = getUserInitials(name)
  const isWaiting = status === "waiting"

  return (
    <div className={cn(
      "flex items-center justify-between p-3 rounded-lg hover:bg-surface-hover transition-colors cursor-pointer group",
      isWaiting && "opacity-75",
      className
    )}>
      <div className="flex items-center gap-3">
        {avatar ? (
          <AvatarImage
            src={avatar}
            alt={name}
            className="w-10 h-10 rounded-full border border-border"
          />
        ) : (
          <div className={cn(
            "w-10 h-10 rounded-full flex items-center justify-center text-white text-sm font-bold border border-border",
            initials.startsWith('J') ? "bg-indigo-500" : "bg-pink-500"
          )}>
            {initials}
          </div>
        )}
        <div>
          <p className="text-foreground text-sm font-bold">{name}</p>
          <p className="text-muted-foreground text-xs">{role}</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        {status === "confirmed" ? (
          <Icon name="check_circle" className="text-green-500 text-lg" aria-label="Confirmado" />
        ) : status === "pending_payment" ? (
          <Icon name="hourglass_top" className="text-amber-500 text-lg" aria-label="Aguardando Pagamento" />
        ) : (
          <Icon name="hourglass_empty" className="text-yellow-500 text-lg" aria-label="Lista de Espera" />
        )}
      </div>
    </div>
  )
}
